import { css } from '@/styled-system/css';

export const bannerBodyStyles = css.raw({
  display: 'flex',
  justifyContent: 'center',
  flex: '0 1 auto',
  gap: 'default',
  color: 'inherit',
  textStyle: 'body',
});
